<script lang="ts">
  import type { ClassValue } from 'svelte/elements'

  interface Props {
    class?: ClassValue
  }

  let { class: className = 'size-7' }: Props = $props()

  let logoVisible = $state(true)
</script>

{#if logoVisible}
  <img
    src="/images/site/logo.svg"
    alt="Суперфуд Фарм"
    class={[className, 'object-contain']}
    onerror={() => (logoVisible = false)}
  />
{:else}
  <svg class={className} viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <path
      d="M14 2C7.373 2 2 7.373 2 14s5.373 12 12 12 12-5.373 12-12S20.627 2 14 2zm0 4c1.5 0 2.8.6 3.8 1.5C16 9.5 15 12 14 14c-1 2-2 4-4 4.5A8 8 0 0 1 14 6zm0 16c-2 0-3.8-.7-5.2-1.9 1.2-1.5 3.5-2.1 5.2-4.6 1 1.8 1.8 3.4 2 5-1.5.5-.7.5-2 1.5z"
      fill="#7AB547"
    />
    <circle cx="14" cy="14" r="3" fill="#7AB547" opacity=".5" />
  </svg>
{/if}
